import { MakingRecordAssessments, UploadAudioFile, AudioCuttingAssessments, AudioCutting, Payments } from 'components'
import { LinguisticLab, AudioTranscription, AssessmentDef, Assessment, CreateAssessments, Transcription, Tutorials, AssessmentDefs, Users, TranscriptionSystem, Assessments, TestTakers, Normalizer, Dashboard, Report, Newsletter, CreateNewsletter, MatchingLearning, PerformAssessments, ViewNewsletter, PerformAssessment, WordReadability } from 'pages'
import { transcription, createAssessment, uploadAudioFile, rating, assessment, matchingLearning, createAssessmentRecord, assessmentDefs, testTakers, assessments, allAssessments, createAssessments, assessmentDef, adminAssessments, markingWords, cutAudio, assessmentView, makingRecordAssessments, learningResources, audioTranscription, linguisticLab, audioCutting, dashboard, app, payments, contactUs, users, newsletter, newsletters } from "router/routes";
import { AssessmentDefs as AudioTranscriptionAssessments } from 'pages/School/AudioTranscription';
import { ExistAssessmentAlert } from 'pages/School/PerformAssessment';

const useAppRoutes = () => {

    const permissionParams = {
        permissionHOC: "hidden",
        role: "read"
    }

    const appRoutes = [
        {
            id: 123,
            path: dashboard,
            element: Dashboard,
            feature: "dashboard",
            isGeneralPage: true,
            title: "לוח בקרה",
            ...permissionParams
        },
        {
            id: 10,
            path: testTakers,
            element: TestTakers,
            isGeneralPage: true,
            feature: "test-takers",
            title: "תלמידים",
            ...permissionParams
        },
        {
            id: 1,
            path: rating,
            element: Report,
            feature: "rating",
            title: "דוח אישי",
            ...permissionParams
        },
        {
            id: 22,
            path: `${assessmentView}/:assessmentID`,
            element: Assessment,
            feature: "assessment",
            title: "מבדק",
            ...permissionParams
        },
        {
            id: 22,
            path: `${assessmentView}`,
            element: Assessment,
            feature: "assessment",
            title: "מבדק",
            ...permissionParams
        },
        {
            id: 3,
            path: `${matchingLearning}/:assessmentID`,
            element: MatchingLearning,
            feature: "matching-learning",
            title: "למידה מותאמת",
            ...permissionParams
        },
        {
            id: 4,
            path: assessmentDef,
            element: AssessmentDef,
            feature: "assessment-def",
            title: "מבדק",
            ...permissionParams
        },
        {
            id: 666,
            path: makingRecordAssessments,
            element: MakingRecordAssessments,
            title: "הקלטת אבחון",
            feature: "create-record-assessment",
            ...permissionParams
        },
        {
            id: 7,
            path: assessments,
            element: Assessments,
            isGeneralPage: true,
            feature: "assessments",
            breadcrumbs: true,
            title: "דוחות",
            ...permissionParams
        },
        {
            id: 77,
            path: `${assessments}/:assessmentID`,
            element: Report,
            feature: "assessment",
            title: "דוח אישי",
            ...permissionParams
        },
        {
            id: 8,
            path: assessmentDefs,
            element: AssessmentDefs,
            feature: "assessment-defs",
            title: "מבדקים",
            ...permissionParams
        },
        {
            id: 88,
            path: `${assessmentDefs}/:assessmentDefID`,
            element: AssessmentDef,
            feature: "assessment-defs",
            title: "מבדק",
            ...permissionParams
        },
        {
            id: 9,
            path: allAssessments,
            element: PerformAssessments,
            isGeneralPage: true,
            feature: "all-assessments",
            title: "אבחונים פעילים",
            ...permissionParams
        },
        {
            id: 99,
            path: app.performAssessmentById,
            element: PerformAssessment,
            isGeneralPage: true,
            exitAlert: ExistAssessmentAlert,
            feature: "perform-assessment",
            title: "",
            ...permissionParams
        },
        {
            id: 10,
            path: createAssessments,
            element: CreateAssessments,
            feature: "create-assessments",
            title: "הקצאת אבחונים",
            isGeneralPage: true,
            ...permissionParams
        },
        // {
        //     id: 11,
        //     path: `${uploadAudioFile}/:testTakerID`,
        //     element: UploadAudio,
        //     feature: "create-upload-assessment",
        //     title: "העלאת אבחון",
        //     ...permissionParams
        // },
        {
            id: 6,
            path: "/manage/*",
            element: TranscriptionSystem,
            isGeneralPage: true,
            feature: "admin-assessments",
            ...permissionParams
        },
        {
            id: 7,
            path: learningResources,
            element: AudioTranscriptionAssessments,
            isGeneralPage: true,
            feature: "voice-lab",
            ...permissionParams
        },
        {
            id: 999,
            path: app.audioTranscriptionById,
            element: AudioTranscription,
            isGeneralPage: true,
            feature: "voice-lab",
            title: "",
            ...permissionParams
        },
        {
            id: 9,
            path: `${transcription}/:assessmentID`,
            element: Transcription,
            title: "פענוח אודיו",
        },

        {
            id: 13,
            path: app.textReadability,
            element: LinguisticLab,
            title: "מעבדה לשונית",
            isGeneralPage: true,
            feature: "linguistic-lab",
            ...permissionParams
        },
        {
            id: 133,
            path: app.wordReadability,
            element: WordReadability,
            title: "מעבדה לשונית",
            isGeneralPage: true,
            feature: "linguistic-lab",
            ...permissionParams
        },
        {
            id: 134,
            path: app.normalizer,
            element: Normalizer,
            title: "קביעת נורמות",
            isGeneralPage: true,
            feature: "child-development",
            ...permissionParams
        },
        {
            id: 133,
            path: users,
            element: Users,
            title: "משתמשים",
            isGeneralPage: true,
            feature: "users",
            ...permissionParams
        },
        {
            id: 143,
            path: newsletters,
            element: Newsletter,
            title: "מה חדש?",
            isGeneralPage: true,
            feature: "newsletter",
            ...permissionParams
        },
        {
            id: 143,
            path: app.createNewsletter,
            element: CreateNewsletter,
            featurePath: newsletters,
            title: "מה חדש?",
            breadcrumbs: true,
            isGeneralPage: true,
            feature: "newsletter",
            ...permissionParams
        },
        {
            id: 1433,
            path: app.editNewsletter,
            breadcrumbs: true,
            featurePath: newsletters,
            element: CreateNewsletter,
            title: "מה חדש?",
            isGeneralPage: true,
            feature: "newsletter",
            ...permissionParams
        },
        {
            id: 1433,
            path: app.newslettersById,
            breadcrumbs: true,
            featurePath: newsletters,
            element: ViewNewsletter,
            title: "מה חדש?",
            isGeneralPage: true,
            feature: "newsletter",
            ...permissionParams
        },
        {
            id: 1433,
            path: "/tutorials/*",
            element: Tutorials,
            isGeneralPage: true,
            feature: "tutorials",
            hidePadding: true,
            ...permissionParams
        },
        {
            id: 5,
            path: "/",
            navigate: app.dashboard,
            isGeneralPage: true,
            feature: "dashboard",
            ...permissionParams
        },
        {
            id: 5,
            path: "/",
            navigate: app.allAssessments,
            isGeneralPage: true,
            feature: "students",
            ...permissionParams
        },
        {
            id: 55,
            path: `/*`,
            navigate: app.markingWordsAssessments,
            isGeneralPage: true,
            feature: "admin-assessments",
            ...permissionParams
        }
    ]

    return appRoutes
}

export default useAppRoutes